import React, { useState, useEffect } from "react";
import { getLegalPage } from "../lib/api";
import BlocksRenderer from "../components/BlocksRenderer";
import { Page } from "../components/ui";
import "../styles/LegalPage.css";

/**
 * Deliberately not using PageHeader here: Impressum/Datenschutz/
 * Barrierefreiheit have no breadcrumb, no subtitle and no accent
 * color — they're plain legal text, not part of the content-page
 * family. What it does share with every other page: <Page>'s
 * loading/error handling, so a slow or failed fetch looks the same
 * everywhere.
 */
export default function LegalPage({ section, fallbackTitle }) {
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("loading"); // loading | ready | error

  useEffect(() => {
    let cancelled = false;
    setStatus("loading");
    getLegalPage()
      .then((res) => {
        if (!cancelled) {
          setData(res);
          setStatus("ready");
        }
      })
      .catch((err) => {
        console.error(err);
        if (!cancelled) setStatus("error");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const title = data?.[`${section}Title`] || fallbackTitle;
  const content = data?.[`${section}Content`] ?? [];
  const hasContent = Array.isArray(content) && content.length > 0;

  return (
    <Page className="legal-page" loading={status === "loading"} error={status === "error" ? true : null}>
      <header className="legal-page__header">
        <div className="container">
          <h1>{title}</h1>
        </div>
      </header>

      <section className="legal-page__section">
        <div className="container">
          {hasContent ? (
            <div className="legal-page__content">
              <BlocksRenderer content={content} />
            </div>
          ) : (
            <p>Für diese Seite ({fallbackTitle}) wurde in Strapi noch kein Inhalt hinterlegt.</p>
          )}
        </div>
      </section>
    </Page>
  );
}